module.exports = __webpack_public_path__ + "static/media/gestoria-tickets-rojo.d3e8a33a.svg";